<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目立项批文记录</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <create-setup
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          ></create-setup>

          <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments
                :projectId="form.projectId"
                :contractId="form.contractId"
                ref="attachments"
                :arr="attachmentArr"
                :type="994"
              ></attachments>
            </el-form-item>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="createProject()"
                class="form-btn"
                type="success"
                >确认提交项目立项批文记录</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import CreateSetup from "@/page/form/createSetup";

import ObjectUtil from "../mixins/objectUtil";
export default {
  mixins: [ObjectUtil],
  components: {
    CreateSetup,
    Attachments,
  },
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      project: {},
      form: {
        projectId: "",
        lxpwh: "",
        intro: "",
      },
      hasSetup: false,
      attachmentArr: [],
      formLoading: false,
    };
  },
  mounted() {
    this.form.projectId = this.$route.params.projectId;
    this.getProject();
    this.getSetupDetail();
  },
  methods: {
    // 获取历史立项信息
    getSetupDetail() {
      this.formLoading = true;
      ajax.get("/gc/project/setup/info/" + this.form.projectId, "", (res) => {
        if (res.vo) {
          this.hasSetup = true;
          this.form.lxpwh = res.vo.lxpwh;
          this.form.intro = res.vo.intro;
          this.attachmentArr = res.vo.attachments ? res.vo.attachments : [];
        }
        this.formLoading = false;
      });
    },
    // 获取项目
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);

        this.form.intro = this.project.intro;
      });
    },
    // 提交项目申请
    createProject() {
      this.form.attachments = this.$refs.attachments.getAttachments();

      this.formLoading = true;
      let _url = !this.hasSetup
        ? "/gc/project/setup"
        : "/gc/project/setup/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.$message.success("提交项目立项结果成功");
          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createSetup.vue